import type { GateStatusOut } from "../../api/types/allocation";

const STYLES: Record<string, { bg: string; fg: string; label: string }> = {
  ok: { bg: "#064e3b", fg: "#a7f3d0", label: "Gate OK" },
  blocked: { bg: "#7c2d12", fg: "#fed7aa", label: "Gate blocked" },
  stale: { bg: "#334155", fg: "#cbd5e1", label: "Gate stale" },
};

export function GateBanner({
  gate,
  onOpenImports,
}: {
  gate: GateStatusOut;
  onOpenImports: () => void;
}) {
  const s = STYLES[gate.status] ?? STYLES.stale;
  return (
    <div
      style={{
        display: "flex", alignItems: "center", gap: 12,
        background: s.bg, color: s.fg, padding: "8px 12px", borderRadius: 6, marginBottom: 12,
      }}
      role="status"
    >
      <strong>● {s.label}</strong>
      <span style={{ opacity: 0.9 }}>{gate.reason}</span>
      <span style={{ marginLeft: "auto" }}>
        <button
          type="button"
          onClick={onOpenImports}
          style={{ color: s.fg, background: "transparent", border: `1px solid ${s.fg}`, borderRadius: 4, padding: "2px 8px", cursor: "pointer" }}
        >
          Imports{gate.status !== "ok" ? " →" : ""}
        </button>
      </span>
    </div>
  );
}
